import * as React from 'react'

import { angleDown, angleUp } from '../../icons/index'
import type { LinkViewModel } from '../../view-models/LinkViewModel'
import Button from '../Button/Button'
import Dropdown from '../Dropdown/Dropdown'
import DropdownLinks from '../DropdownLinks/DropdownLinks'
import Icon from '../Icon/Icon'
import styles from './pageLogin-style.css'
import cx from 'classnames'

type Props = {
  loggedIn?: boolean
  title?: string
  items?: Array<LinkViewModel>
  align?: 'right' | 'left'
}
type State = {}
const eventMeta = {
  event: 'menu-login',
}

class PageLogin extends React.Component<Props, State> {
  static displayName = 'PageLogin'
  static defaultProps = {}

  get renderLoggedIn() {
    const { items, loggedIn, title, align = 'right' } = this.props

    if (!items) {
      return null
    }

    if (loggedIn) {
      const item: LinkViewModel | undefined = items ? items.shift() : {}

      return (
        <Button {...item} className={styles.button}>
          {/* <Icon iconName="Unlock" /> */} {title}
        </Button>
      )
    } else {
      return (
        <Dropdown
          title={(handleShowMenu, dropdownVisible) => {
            return (
              <Button
                small
                className={styles.button}
                onClick={handleShowMenu}
                eventMeta={dropdownVisible ? {} : eventMeta}
              >
                {title}
                <Icon iconSrc={dropdownVisible ? angleUp : angleDown} height="16px" width="16px" />
              </Button>
            )
          }}
        >
          <DropdownLinks
            items={items}
            position={align}
            className={cx(styles.pageLogin, styles[align])}
            eventName="login"
          />
        </Dropdown>
      )
    }
  }

  render() {
    const items = this.props.items
    if (!items) return null

    return <div className={styles.pageLogin}>{this.renderLoggedIn}</div>
  }
}

export default PageLogin